export const DELETE_MEETING_TEMPLATE_TEXT = {
    id: `oe.meetingTemplate.deleteMeetingTemplate`,
    description: 'Label text',
    defaultMessage: 'Delete Template',
};

export const NO_STATUS_SELECTED_TEXT = {
    id: 'oe.meetingTemplate.noStatusSelected',
    description: 'Label text',
    defaultMessage: 'No Status Selected',
};

export const NO_ACCESS_SELECTED_TEXT = {
    id: 'oe.meetingTemplate.noAccessSelected',
    description: 'Label text',
    defaultMessage: 'No Access Selected',
};

export const DISABLE_OTHER_PAGES_TEXT = {
    message: 'Disable all other pages',
    id: 'oe.templates.meeting.disableOtherPages',
    description: 'Label text',
};

export const SHOW_LINK_ON_WELCOME_PAGE_TEXT = {
    message: 'Show link on Welcome page',
    id: 'oe.defaultPages.showLinkOnWelcomePage',
    description: 'Label text',
};

export const REPLAYS_AVAILABLE_INFO_MESSAGE_TEXT = {
    id: 'oe.meeting.replaysAvailableInfoMessage',
    description: 'Info Message',
    defaultMessage: `If this toggle is enabled, the meeting will appear on the Replays page in Passport once the meeting end time is in the past.
            You can only enable this toggle if the Meeting Access is Open or Plenary.`
};

export const FEATURED_MEETING_INFO_MESSAGE_TEXT = {
    id: 'oe.meeting.featuredMeetingInfoMessage',
    description: 'Info Message',
    defaultMessage: 'Featured Presentations are displayed as larger cards on both the General Sessions and Replays pages in Passport.',
};

export const FEATURED_PRESENTATION_TEXT = {
    message: 'Featured Presentation is {suffix}',
    id: 'oe.meetingTemplate.featuredPresentation',
    description: 'Label text',
};

export const ENABLE_ON_REPLAYS_PAGE_TEXT = {
    message: '{prefix} available on Replays page',
    id: 'common.enableOnReplaysPage',
    description: 'Label text',
};

export const SINGLE_MEETING_CUSTOM_PAGE_TEXT = {
    message: 'Create Single Meeting Custom Page is {suffix}',
    id: 'oe.meetingTemplate.singleMeetingCustomPage',
    description: 'Label text',
};

export const ASSIGNED_AS_LANDING_PAGE_TEXT = {
    message: '{prefix}Assigned as Landing Page',
    id: 'oe.templates.meeting.assignedAsLandingPage',
    description: 'Label text',
};

export const APPLY_CONNECTIONS_TEMPLATE_TEXT = {
    message: 'Apply a Connection Template is {suffix}',
    id: 'oe.templates.meeting.applyConnectionsTemplate',
    description: 'Label text',
};

export const RECORD_MEETING_ENABLE_TEXT = {
    message:'Record Meeting: {suffix}',
    id:'common.recordMeetingEnable',
    description:'Label text',
};

export const EXPIRY_DATE_TEMPLATE_INFO_TEXT = {
    id: 'oe.meetingTemplate.expiryDateInfo',
    defaultMessage: 'Meeting will become unavailable {days, plural, one {# day} other {# days}} after the meeting date.',
    description: 'Info text for expiry date field in meeting template form',
};